export default "__VITE_ASSET__e5183672__"